<template>
    <div class="addressList">
        <!-- 头部 -->
        <div class="header">
            <div class="header-left" @click="back">
            <span class="iconfont iconzuojiantou"></span>
            </div>
            <div class="header-center">
            <p>地址管理</p>
            </div>
            <div class="header-rigth">
            
            </div>
        </div>
        <!-- 地址 -->
        <div class="addressOut">
          <van-radio-group v-model="radio">
            <div class="addressInner" v-for="(item,index) in Address" :key="index">
                    <van-radio :name="index" checked-color="#07c160">
                    <div class="information">
                        <div class="namePhone">
                            <div class="name">{{Address[index].guestName}}</div>
                            <div class="phone">{{Address[index].guestPhone}}</div>
                        </div>
                        <div class="address"> {{Address[index].guestAddress}}</div>
                    </div>
                    </van-radio>
                   <p class="editing" @click="editing(index)">编辑</p>
            </div>
          </van-radio-group>
        </div>
        <!-- 按钮 -->
        <div class="button" v-show="isShowBtn">
            <van-button size="large" class="addAddress" @click="addAddress">添加地址</van-button>
            <van-button size="large" class="back" @click="back">返回</van-button>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
           radio: null,
           Address: [],
           isShowBtn: false
        }
    },
    created (){
        // 获取地址请求
        this.$axios.get('/api/DjAddress/GetAddressList').then(res => {
         let data = res.data
         this.Address = data
         this.Address.forEach((item,index) => {
           if(item.defaultAddress == 1){
             this.radio = index
           }
         })
        this.isShowBtn = true
        
       })
    },
     methods: {
      back () {
          this.$router.back()
      },
      editing (index) {
         let editingAddress = this.Address[index]
         
         this.$router.push('/editingaddress?data='+ JSON.stringify(editingAddress))
      },
      addAddress () {
          this.$router.push('/addadderss')
      }
      
   }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.addressList
  .header
    position: fixed
    z-index: 90
    left: 0
    right: 0
    top: 0
    display: flex
    justify-content: space-between
    width: 100%
    height: 40px
    align-items: center
    background-color: white
    font-weight: bold
    .header-left
     padding-left: 8px
     height: 100%
     width: 40px
     display: flex
     align-items: center
   .header-center
     font-size: 20px
     width: 120px
  .addressOut
    width: 100%
    margin-top: 54px
    .addressInner
      width: 90%
      display: flex
      justify-content: space-between
      align-items: center
      margin: auto
      border-bottom: 1px solid #eee
      padding-bottom: 8px
      padding-top: 8px
      >>>.van-radio
       width: 86%
       display: flex
       align-items: center
      & .information
        display: flex
        flex-direction: column
        .namePhone
          display: flex
          margin-bottom: 4px
          .name
            margin-right: 4px
        .address
          font-size: 14px
          color: #bfbfbf
      .editing
        font-size: 14px
        color: red
  .button
    width: 100%
    margin-top: 10px
    display: flex
    flex-direction: column
    align-items: center
    .confirm
      width: 90%
      margin-bottom: 10px
      color: white
      background: #009933
      border-radius: 6px
      font-size: 18px
    .addAddress
      width: 90%
      margin-bottom: 10px
      color: white
      background: #009933
      border-radius: 6px
      font-size: 18px
    .back
      width: 90%
      margin-bottom: 10px
      border-radius: 6px
      font-size: 18px

      
       



</style>



// WEBPACK FOOTER //
// src/pages/Address/AddressDirectories.vue